import React from 'react';
import AixueHeader from '@/components/AixueHeader/index';
import styles from './index.module.scss';
import downloadBackground1 from '@/assets/download/download-bg-1.png';
import downloadMobileEg from '@/assets/download/download-mobile-eg.png';
import downloadMobileAi from '@/assets/download/download-mobile-ai.png';
import downloadIphone from '@/assets/download/download-iphone.png';
import downloadAndroid from '@/assets/download/download-android.png';
import downloadQR from '@/assets/download/download-qr.png';
import downloadScanTxt from '@/assets/download/download-scan-txt.png';

export default function Screen1() {
  return (
    <section
      className={styles['download-section-1']}
      style={{ '--background-1-url': `url(${downloadBackground1})` } as React.CSSProperties}
    >
      <div className={styles['download-header']}>
        <AixueHeader title="爱学" />
      </div>

      <div className={styles['download-wrap']}>
        <div className={styles['download-content']}>
          <div className={styles['download-titleBig']}>爱学移动客户端</div>
          <div className={styles['download-desc']}>爱学移动端支持手机端+平板端</div>
          <img
            className={styles['download-scan-txt']}
            src={downloadScanTxt}
            alt="download-scan-txt"
          />
          <div className={styles['download-icon-row']}>
            <div className={styles['download-icon-item']}>
              <span className={styles['download-icon-box']}>
                <span className={styles['download-icon-inner']}>
                  <img className={styles['download-icon']} src={downloadIphone} alt="iPhone 下载" />
                </span>
              </span>
              <div className={styles['download-txt-item']}>版本大于等于13.0</div>
            </div>
            <div className={styles['download-icon-item']}>
              <span className={styles['download-icon-box']}>
                <span className={styles['download-icon-inner']}>
                  <img
                    className={styles['download-icon']}
                    src={downloadAndroid}
                    alt="Android 下载"
                  />
                </span>
              </span>
              <div className={styles['download-txt-item']}>版本大于等于7.0</div>
            </div>
            <div className={styles['download-icon-item']}>
              <span className={styles['download-icon-box']}>
                <img className={styles['download-icon']} src={downloadQR} alt="扫码下载" />
              </span>
              <div className={styles['download-txt-item']}>扫码下载</div>
            </div>
          </div>
        </div>
        <div className={styles['download-eg-wrap']}>
          <img className={styles['download-eg']} src={downloadMobileEg} alt="download-eg" />
          <img className={styles['download-ai']} src={downloadMobileAi} alt="download-ai" />
        </div>
      </div>
    </section>
  );
}
